import BaseService from './BaseService';
import entities from 'src/config/entities';
class LanguageService extends BaseService{

  constructor() {
    super({ entity: entities.LANGUAGE });
  }
}

export default new LanguageService();
